import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-editor-custom-component-aniversariantes',
  templateUrl: 'aniversariantes.component.html',
  styleUrls: ['./aniversariantes.component.scss']
})
export class AniversariantesComponent {
    @Input() item: any;
}
